module.exports = __webpack_public_path__ + "static/img/tutorial3_3.51e4e23.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/coin_dealer/tutorial3_3.png
// module id = ib0L
// module chunks = 0